import createCountryFormatter from "./formatters/createCountryFormatter.js";
import createCurrencySymbolFormatter from "./formatters/createCurrencySymbolFormatter.js";
import createDateFormatter from "./formatters/createDateFormatter.js";
import createDistanceFormatter from "./formatters/createDistanceFormatter.js";
import createListFormatter from "./formatters/createListFormatter.js";
import createLocaleFormatter from "./formatters/createLocaleFormatter.js";
import createMessageFormatter from "./formatters/createMessageFormatter.js";
import createNumberFormatter from "./formatters/createNumberFormatter.js";
import createPriceFormatter from "./formatters/createPriceFormatter.js";
import createRelativeDateFormatter from "./formatters/createRelativeDateFormatter.js";
export function getI18n(locale, currencyCode, showTranslationKeys, showDefaultMessage, shouldLogMissingTranslationValue) {
  const messageFormatter = createMessageFormatter({
    locale,
    showDefaultMessage,
    showTranslationKeys,
    currencyCode,
    shouldLogMissingTranslationValue
  });
  const formatter = messageFormatter;
  formatter.date = createDateFormatter(locale);
  formatter.relativeDate = createRelativeDateFormatter(locale);
  formatter.number = createNumberFormatter(locale);
  formatter.country = createCountryFormatter(locale);
  formatter.language = createLocaleFormatter(locale);
  formatter.distance = createDistanceFormatter(locale, messageFormatter);
  formatter.list = createListFormatter(locale);
  formatter.price = createPriceFormatter(locale, currencyCode);
  formatter.currencySymbol = createCurrencySymbolFormatter(locale, currencyCode);
  formatter.currentLocale = locale;
  formatter.currentCurrency = currencyCode;
  formatter.currencySign = formatter.currencySymbol;
  formatter.locale = formatter.language;
  return formatter;
}
